import { Component, Input, ViewChild } from '@angular/core';

import { IModalDialogInputData } from '../../interfaces/modal-dialog.interface';
import { ColorFilter } from '../../../../shared/constants/color-filter';
import { IModal } from '../modals/modal.interface';
import { ModalContainerComponent } from '../modals/modal-container.component';

export interface IImageData {
  imageSrc: string;
  alt: string;
  filter?: ColorFilter;
}

@Component({
  selector: 'app-overlay-image',
  templateUrl: './overlay-image.component.html',
  styleUrls: ['./overlay-image.component.scss'],
  standalone: false,
})
export class OverlayImageComponent implements IModal {
  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;

  @Input() public modalInputData: IModalDialogInputData<IImageData>;

  public get filter(): string {
    const filter: ColorFilter = this.modalInputData.data.filter;
    return filter in ColorFilter ? `url(#${filter})` : '';
  }
}
